<app-modal-dialog (backdropClick)="cancelled.emit()">
  <div header>
    <div class="heading-md">{{ 'dnc.confirmDialog.title' | translate }}</div>
  </div>
  <div content>
    <p class="modal-description">{{ 'dnc.confirmDialog.description' | translate }}</p>
    @if (address?.do_not_contact_reason) {
      <p class="dnc-reason" data-testid="dnc-confirm-reason">{{ address!.do_not_contact_reason }}</p>
    }
  </div>
  <div footer>
    <app-button variant="text" (click)="cancelled.emit()" data-testid="dnc-confirm-cancel-button">
      {{ 'dnc.confirmDialog.cancel' | translate }}
    </app-button>
    <app-button variant="filled" color="primary" (click)="confirmed.emit()" data-testid="dnc-confirm-continue-button">
      {{ 'dnc.confirmDialog.confirm' | translate }}
    </app-button>
  </div>
</app-modal-dialog>
